const JobsActions = {
  SET_JOBS: 'SET_JOBS',
  SET_RECOMMENDED_JOBS: 'SET_RECOMMENDED_JOBS',
  START_FETCHING_RECOMMENDED_JOBS: 'START_FETCHING_RECOMMENDED_JOBS',
  END_FETCHING_RECOMMENDED_JOBS: 'END_FETCHING_RECOMMENDED_JOBS',
  START_APPLYING_RECOMMENDED_JOBS: 'START_APPLYING_RECOMMENDED_JOBS',
  FINISH_APPLYING_RECOMMENDED_JOBS: 'FINISH_APPLYING_RECOMMENDED_JOBS',
  ERROR_APPLYING_RECOMMENDED_JOBS: 'ERROR_APPLYING_RECOMMENDED_JOBS',
  SET_FASTRACK_FLOWS: 'SET_FASTRACK_FLOWS',
  START_FETCHING_FASTRACK_FLOWS: 'START_FETCHING_FASTRACK_FLOWS',
  END_FETCHING_FASTRACK_FLOWS: 'END_FETCHING_FASTRACK_FLOWS',
  START_FETCHING_JOBS_APPLIED:'START_FETCHING_JOBS_APPLIED',
  END_FETCHING_JOBS_APPLIED:'END_FETCHING_JOBS_APPLIED',
  SET_JOBS_APPLIED:'SET_JOBS_APPLIED',
  START_FETCHING_V2_JOBS: 'START_FETCHING_V2_JOBS',
  SET_V2_JOBS: 'SET_V2_JOBS',
  SET_PENDING_JRF: 'SET_PENDING_JRF',
  END_FETCHING_V2_JOBS: 'END_FETCHING_V2_JOBS'
};

export default JobsActions;
